import { styled } from '@mui/material/styles';
import { MaterialDesignContent } from 'notistack';

const CustomSnackBar = styled(MaterialDesignContent)(() => ({
    '&.notistack-MuiContent-success': {
        backgroundColor: 'white',
        color: 'black',
        svg: { fill: '#43a047 !important' }
    },
    '&.notistack-MuiContent-info': {
        backgroundColor: 'white',
        color: 'black',
        svg: { fill: '#2196f3 !important' }
    },
    '&.notistack-MuiContent-error': {
        backgroundColor: 'white',
        color: 'black',
        svg: { fill: '#d32f2f !important' }
    }
}));

export default CustomSnackBar;
